import i18next from 'i18next'
import { ReactNode } from 'react'

import PaymentGraphicPage from 'components/pageClient/applicationForm/2_PaymentGraphic/PaymentGraphicPage'
import BankCardForm from 'components/pageClient/applicationForm/4_BankCardPage/BankCardPage'
import VerificationPage from 'components/pageClient/applicationForm/5_verificationPage/verificationPage'
import CollateralPage from 'components/pageClient/applicationForm/CollateralPage/CollateralPage'
import CreditInfoPage from 'components/pageClient/applicationForm/CreditInfoPage/CreditInfoPage'
import GarantorPage from 'components/pageClient/applicationForm/garantorPage/GarantorPage'
import TranchesPage from 'components/pageClient/applicationForm/TranchesPage/TranchesPage'
import { ClientApplication } from 'components/pageClient/ClientApplication/ClientApplication'
import { ICreditProduct } from 'redux/reducers/lender/allState/types/state'

export type TStepName =
  | 'prodcut_info'
  | 'payment'
  | 'tranches'
  | 'test_application'
  | 'collateral'
  | 'bank_card'
  | 'guarantor'
  | 'verification'

export interface IApplicationStep {
  name: TStepName
  isShow: boolean
  component: ReactNode
  title: string
}

export const getApplicationSteps = (policy: ICreditProduct) => {
  const { t } = i18next
  const { is_guarantor_required, is_tranches_enabled, collaterals, credit_type, is_prepayment } = policy

  const steps: IApplicationStep[] = [
    {
      name: 'prodcut_info',
      isShow: is_prepayment,
      component: <CreditInfoPage />,
      title: t('client.applicationForm.steps.credit')
    },
    {
      name: 'payment',
      isShow: true,
      component: <PaymentGraphicPage />,
      title: t('client.applicationForm.steps.payment')
    },
    {
      name: 'tranches',
      isShow: is_tranches_enabled,
      component: <TranchesPage />,
      title: t('client.applicationForm.steps.tranches')
    },
    {
      name: 'test_application',
      isShow: true,
      component: <ClientApplication />,
      title: t('client.applicationForm.steps.applicationForm')
    },
    {
      name: 'collateral',
      isShow: !!collaterals.length,
      component: <CollateralPage />,
      title: t('client.applicationForm.steps.collateral')
    },
    {
      name: 'bank_card',
      isShow: true,
      component: <BankCardForm />,
      title: t('client.applicationForm.steps.bankCard')
    },
    {
      name: 'guarantor',
      isShow: is_guarantor_required,
      component: <GarantorPage />,
      title: t('client.applicationForm.steps.guarantor')
    },
    {
      name: 'verification',
      isShow: true,
      component: <VerificationPage />,
      title: t('client.applicationForm.steps.verification')
    }
  ]

  return steps.filter(({ isShow }) => isShow)
}
